import { render } from "./AdminDeviceDetail.vue?vue&type=template&id=1798ac6d"
import script from "./AdminDeviceDetail.vue?vue&type=script&lang=js"
export * from "./AdminDeviceDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__